import type { Locale } from "~/types";

const localize = {
  ru: {
    actionButton: "Оформить заявку",
    approved: "Вам одобрено",
    specialСonditions: "Для вас специальные условия",
  },
  uk: {
    actionButton: "Оформити заявку",
    approved: "Вам схвалено",
    specialСonditions: "Для вас спеціальні умови",
  },
  kz: {
    actionButton: "Өтініш жасаңыз",
    approved: "Сіз мақұлдадыңыз",
    specialСonditions: "Сізге арнайы шарттар",
  },
};

export default (selector: keyof (typeof localize)[Locale]) => {
  return localize[getLanguage()][selector];
};
